<template>
    <div class="navBox">
        <div class="navTxt" @click="toHome"><i class="huodong icon-zhuye"></i>首页</div>
        <div class="navTxt" @click="toRank" v-if="actInfo.dis_btn && (actInfo.dis_btn.includes('phb'))"><i class="huodong icon-gongsiqiye1"></i>活动榜单</div>
        <div class="navTxt" @click="toMyCenter"><i class="huodong icon-wode1"></i>个人中心</div>
    </div>
</template>

<script>
export default {
    name: 'NavBox',
    props: {
        // 首页跳转路径：活动首页(/index)或课程列表(/list)
        homePath: {
            type: String,
            default: '/index'
        },
        // 活动信息
        actInfo: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        toHome() {
            this.$router.push({ path: this.homePath, query: this.$route.query })
        },
        toRank() {
            this.$router.push({ path: '/rank', query: this.$route.query })
        },
        toMyCenter() {
            this.$router.push({ path: '/mycenter', query: this.$route.query })
        }
    }
}
</script>

<style lang="scss" scoped>
    .navBox{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0px;
        width: 750px;
        height: 100px;
        background: #f9f9f9;
        border-top: 1px solid #c8c8c8;
        display: flex;
        justify-content: space-evenly;
        font-size: 30px;
        .navTxt{
            padding:0px 50px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #808080;
            font-weight: 400;
            i{
                font-size: 40px;
                margin-right: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>
